import { getContextId } from '@tlx/astro-shared';

export const previewVoucher = (transactionId: number, contextId: number) => {
    window.open(`/execute/wageTransactions?act=view&id=${transactionId}&contextId=${contextId}`, '_blank');
};

export function employeeDetailsLink(employeeId: number) {
    const contextId = getContextId();
    return `/execute/employeeMenu?employeeId=${employeeId}&contextId=${contextId}`;
}

export function employeeSalaryLink(employeeId: number) {
    const contextId = getContextId();
    return `/execute/employeeMenu?employeeId=${employeeId}&contextId=${contextId}#employeeSalary`;
}

export function proxyUserLink() {
    const contextId = getContextId();
    return `/execute/accountantPermissionSettingsMenu?contextId=${contextId}`;
}

export function viewVoucherUrl(voucherId: number) {
    return `/execute/voucher?act=view&DocumentOnly=&id=${voucherId}&contextId=${getContextId()}`;
}

export function previewVoucherUrl(transactionId: number) {
    return `/execute/wageTransactions?act=view&id=${transactionId}&contextId=${getContextId()}`;
}

export function previewPayslipsUrl(transactionId: number) {
    return `/execute/wageTransactionMenu?act=viewPaySlipsByWageTransaction&wageTransactionId=${transactionId}&contextId=${getContextId()}`;
}
